<ap-section-header>
  <ap-section-header-grid
    [iconId]="'ap-basedata-icon'"
    [caption]="'Global__User'"
    [filterPlaceholder]="'Global_Filter'"
    [filterTooltip]="'Global__User'"
    [createText]="'Global__New'"
    [canCreate]="(ApPermissions.EDIT_USERS | getPermission | async) && isCreateNewAllowed()"
    (createDataset)="createNew()"
    (search)="searchIn($event)"
  ></ap-section-header-grid>
</ap-section-header>

<div class="ap-tabstrip-small">
  <kendo-tabstrip (tabSelect)="selectTab($event)" id="usersTabStrip">
    <kendo-tabstrip-tab [selected]="true">
      <ng-template kendoTabTitle>
        <ap-responsive-text key="Global__User" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-users></ap-users>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab *ngIf="showAssigmentTab">
      <ng-template kendoTabTitle>
        <ap-responsive-text key="Global_User_Assignment" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-users-assignment-farm></ap-users-assignment-farm>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab>
      <ng-template kendoTabTitle>
        <ap-responsive-text key="Global_Invitations" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-users-invitation></ap-users-invitation>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab>
      <ng-template kendoTabTitle>
        <ap-responsive-text key="Global_Mail_Contacts" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-user-contacts></ap-user-contacts>
      </ng-template>
    </kendo-tabstrip-tab>

  </kendo-tabstrip>
</div>
